export class Router {
  constructor() {
    this.routes = [];
  }

  async run(path) {
    this.routes.forEach((route) => {
      if (route.match(path)) {
        route.dispatch();
      }
    });
  }

  init() {}
}

export class Route {
  constructor(name, paths, callback) {
    this.name = name;
    this.paths = paths;
    this.callback = callback;
  }

  match(path) {
    return this.paths.some((route) => (new RegExp(route)).test(path));
  }

  async dispatch() {
    return this.callback();
  }
}